export default __webpack_public_path__ + "static/TinyCam-Monitor_19-c96c741fa26f0b16b4ba22141ed0acbe.webp";